import React from 'react';
import { Container, Stack } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { appTranslate } from '../../i18n';
import { BillingCycle } from '../../../type';

interface SubscriptionSummaryProps {
    billingCycle: BillingCycle;
    subscriptionPlanName: string;
    totalPrice: string | null;
    singularPlanPrice: string | null;
    usersCount: number;
}

export const SubscriptionSummary = ({
    singularPlanPrice,
    totalPrice,
    subscriptionPlanName,
    usersCount,
    billingCycle,
}: SubscriptionSummaryProps) => (
    <Container borderRadius="lg" paddingX="8" paddingY="6" backgroundColor="grey_200">
        <Stack
            borderBottomWidth="sm"
            borderColor="grey_500"
            paddingBottom="5"
            marginBottom="4"
            gap="2"
            alignItems="baseline"
        >
            {totalPrice && (
                <Typography color="grey_1100" size="b_lg" fontWeight="bold">
                    {totalPrice}
                </Typography>
            )}
            <Typography color="grey_1100" size="b_md" fontWeight="semibold">
                {subscriptionPlanName}
            </Typography>
        </Stack>
        {singularPlanPrice && (
            <Typography color="grey_1100" size="b_md">
                {appTranslate('subscription_drawer.summary', {
                    params: {
                        subscriptionType: appTranslate(
                            `subscription_drawer.fields.billing_cycle.options.${
                                billingCycle.toLowerCase() as Lowercase<BillingCycle>
                            }.label_options.label_option_2`
                        ),
                        price: appTranslate(
                            'subscription_drawer.fields.billing_cycle.options.monthly.price_options.price_option_2',
                            {
                                params: {
                                    price: singularPlanPrice,
                                },
                            }
                        ),
                        count: usersCount,
                    },
                })}
            </Typography>
        )}
    </Container>
);
